var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showText)?_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.copyText(_vm.text)}}},[_vm._v(_vm._s(_vm.text))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }